import { useState } from 'react';
import { api } from '../lib/api.js';

export function ForgotPasswordModal({ initialEmail, onClose }) {
  const [email, setEmail] = useState(initialEmail || '');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      // Server always returns 200 (avoids email enumeration); just show
      // the same confirmation regardless of whether the email is on file.
      await api('POST', '/api/auth/request-reset', { email: email.trim().toLowerCase() });
    } catch {}
    setSent(true);
    setBusy(false);
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'white', borderRadius: 16, padding: 24, width: '100%', maxWidth: 380 }}>
        {sent ? (
          <>
            <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700 }}>Check your email</h2>
            <p style={{ color: '#666', fontSize: 14, lineHeight: 1.4, marginTop: 0 }}>
              If <strong>{email}</strong> is on file, we just sent a link to set a new password.
              The link expires in 60 minutes.
            </p>
            <button onClick={onClose}
              style={{ marginTop: 16, width: '100%', padding: '10px', background: 'var(--gold)', color: 'white', fontWeight: 600, border: 0, borderRadius: 10, cursor: 'pointer' }}>
              Done
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            <h2 style={{ margin: '0 0 6px', fontSize: 20, fontWeight: 700 }}>Forgot password?</h2>
            <p style={{ color: '#666', fontSize: 13, marginTop: 0, marginBottom: 14 }}>
              Enter your work email and we'll send a link to set a new password.
            </p>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              placeholder="you@empireteaandcoffee.com" autoFocus
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 10, fontSize: 14 }} />
            <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
              <button type="button" onClick={onClose}
                style={{ flex: 1, padding: '10px', background: '#f0f0f0', color: '#444', fontWeight: 600, border: 0, borderRadius: 10, cursor: 'pointer' }}>
                Cancel
              </button>
              <button type="submit" disabled={busy || !email}
                style={{ flex: 1, padding: '10px', background: 'var(--gold)', color: 'white', fontWeight: 600, border: 0, borderRadius: 10, cursor: busy ? 'default' : 'pointer', opacity: busy || !email ? .5 : 1 }}>
                {busy ? 'Sending…' : 'Send link'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
